var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthoritation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1710319161306,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4979,
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M509.088 588.992v-23.872c35.936-22.816 70.656-62.88 89.536-112.064 13.408-5.696 23.04-21.824 30.816-50.56 6.016-22.304-3.648-36.992-16.672-45.12C606.368 252.384 543.808 192 448 192c-97.184 0-162.688 62.144-167.744 169.92-11.808 9.568-19.392 24.864-13.472 46.688 8.416 31.136 18.752 48.992 33.056 55.84 20.224 44.192 53.248 80.032 87.072 101.024v23.52C292.896 598.912 224 631.136 224 669.376c0 46.144 448 46.144 448 0 0-38.24-68.896-70.464-162.912-80.384z",
    "p-id": 4980,
    fill: "#bfbfbf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M864 768V160a96 96 0 0 0-96-96H160a96 96 0 0 0-96 96v608a96 96 0 0 0 96 96h608a96 96 0 0 0 96-96zM128 768V160a32 32 0 0 1 32-32h608a32 32 0 0 1 32 32v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32z",
    "p-id": 4981,
    fill: "#bfbfbf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M944.896 165.856a32 32 0 0 0-32 32v679.104c0 19.84-16.064 35.904-35.904 35.904h-611.2a32 32 0 0 0 0 64h611.2a99.904 99.904 0 0 0 99.904-99.904V197.856a32 32 0 0 0-32-32z",
    "p-id": 4982,
    fill: "#bfbfbf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthoritation);
export default __webpack_public_path__ + "static/media/authoritation.3c639a1311f1f2a6a2b5a517b9358d8f.svg";
export { ForwardRef as ReactComponent };